import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls the main window to the top when the route changes.
 * Does NOT trigger on hash changes (e.g., /page#section).
 * Does NOT affect inner scroll containers like modals, drawers, or sidebars.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only scroll to top if this is a pathname change, not a hash change
    if (!window.location.hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [pathname]);

  return null;
}
